export const SET_ALL_APPLICATIONS = "SET_ALL_APPLICATIONS";
export const GET_APPLICANT_DETAILS = "GET_APPLICANT_DETAILS";
export const DELETE_APPLICATION = "DELETE_APPLICATION";